import type GameDrawLocal from "~/libs/interfaces/GameDrawLocal";
import type GameDrawStrapi from "~/libs/interfaces/GameDrawStrapi";
import gameLocalFactory from "~/libs/factories/GameLocalFactory";
import userLocalFactory from "~/libs/factories/UserLocalFactory";
import gameDrawWinnerLocalFactory from "~/libs/factories/GameDrawWinnerLocalFactory";
import regionLocalFactory from "~/libs/factories/RegionLocalFactory";

const gameDrawLocalFactory = {
  createGameDrawFromStrapi(gameDraw?: GameDrawStrapi): GameDrawLocal | undefined {
    if (!gameDraw) {
      return undefined;
    }
    const serverCurrentTime = gameDraw.currentTime ? new Date(gameDraw.currentTime) : new Date()
    const myTime = new Date()
    const timeDiffMs = myTime.getTime() - serverCurrentTime.getTime()

    useFrontendLogger().debug('GameDrawLocalFactory.createGameDrawFromStrapi', {
      serverCurrentTime: serverCurrentTime.toISOString(),
      myTime: myTime.toISOString(),
      timeDiffMs,
    })

    return {
      id: gameDraw.id,
      documentId: gameDraw.documentId,

      createdAt: gameDraw.createdAt ? new Date(gameDraw.createdAt) : undefined,
      updatedAt: gameDraw.updatedAt ? new Date(gameDraw.updatedAt) : undefined,
      publishedAt: gameDraw.publishedAt ? new Date(gameDraw.publishedAt) : undefined,

      prize: gameDraw.prize || 0,
      accumulatedPrize: gameDraw.accumulatedPrize || 0,

      timeDiffMs,

      startDatetime: gameDraw.startDatetime ? new Date(gameDraw.startDatetime) : undefined,
      countdownDatetime: gameDraw.countdownDatetime ? new Date(gameDraw.countdownDatetime) : undefined,
      drawDatetime: gameDraw.drawDatetime ? new Date(gameDraw.drawDatetime) : undefined,
      closeDatetime: gameDraw.closeDatetime ? new Date(gameDraw.closeDatetime) : undefined,

      winningPsc: gameDraw.winningPsc,
      region: regionLocalFactory.createRegionFromStrapi(gameDraw.region),
      firstWinningUser: userLocalFactory.createUserFromStrapi(gameDraw.first_winning_user),

      hasMeCheckedWin: gameDraw.hasMeCheckedWin,
      isMeWinner: gameDraw.isMeWinner,
      hasWinner: gameDraw.hasWinner,
      hasMeCorrectPsc: gameDraw.hasMeCorrectPsc,
      hasSignedUpForPrize: gameDraw.hasSignedUpForPrize,

      ...(gameDraw.nextDrawTimes && {
        nextDrawTimes: {
          drawCloseTime: gameDraw.nextDrawTimes.drawCloseTime ? new Date(gameDraw.nextDrawTimes.drawCloseTime) : undefined,
          drawCountdownTime: gameDraw.nextDrawTimes.drawCountdownTime ? new Date(gameDraw.nextDrawTimes.drawCountdownTime) : undefined,
          drawStartTime: gameDraw.nextDrawTimes.drawStartTime ? new Date(gameDraw.nextDrawTimes.drawStartTime) : undefined,
          drawTime: gameDraw.nextDrawTimes.drawTime ? new Date(gameDraw.nextDrawTimes.drawTime) : undefined,
        }
      }),

      gameDrawWinner: gameDrawWinnerLocalFactory.createGameDrawFromStrapi(gameDraw.game_draw_winner),
      game: gameLocalFactory.createGameFromStrapi(gameDraw.game),
    }
  }
}
export default gameDrawLocalFactory